
import { RunsheetUnassignedGridRow } from '@/entities/gridTables/model/runsheet/RunsheetUnassignedGridRow'
import { runsheetUnassignedTablesSelector } from '@/entities/gridTables/selectors/runsheetUnassignedTablesSelector'
import { useAppSelector } from '@/shared/store'
import { EntityId } from '@reduxjs/toolkit'

export type RunsheetUnassignedTableData = {
  rows: RunsheetUnassignedGridRow[]
  isLoading: boolean
}

export const useRunsheetUnassignedTableData = (runsheetId: EntityId): RunsheetUnassignedTableData => {
  const runsheetUnassignedTable = useAppSelector(state => runsheetUnassignedTablesSelector.selectById(state, runsheetId))

  return {
    rows: runsheetUnassignedTable?.rows || [],
    isLoading: runsheetUnassignedTable?.isLoading || false,
  }
}
